module.exports = __webpack_public_path__ + "img/1111.938563e1.png";